/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Meta,
  Meta$inboundSchema,
  Meta$Outbound,
  Meta$outboundSchema,
} from "./meta.js";
import {
  RatelimitOverride,
  RatelimitOverride$inboundSchema,
  RatelimitOverride$Outbound,
  RatelimitOverride$outboundSchema,
} from "./ratelimitoverride.js";

export type V2RatelimitGetOverrideResponseBody = {
  meta: Meta;
  data: RatelimitOverride;
};

/** @internal */
export const V2RatelimitGetOverrideResponseBody$inboundSchema: z.ZodType<
  V2RatelimitGetOverrideResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: RatelimitOverride$inboundSchema,
});

/** @internal */
export type V2RatelimitGetOverrideResponseBody$Outbound = {
  meta: Meta$Outbound;
  data: RatelimitOverride$Outbound;
};

/** @internal */
export const V2RatelimitGetOverrideResponseBody$outboundSchema: z.ZodType<
  V2RatelimitGetOverrideResponseBody$Outbound,
  z.ZodTypeDef,
  V2RatelimitGetOverrideResponseBody
> = z.object({
  meta: Meta$outboundSchema,
  data: RatelimitOverride$outboundSchema,
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace V2RatelimitGetOverrideResponseBody$ {
  /** @deprecated use `V2RatelimitGetOverrideResponseBody$inboundSchema` instead. */
  export const inboundSchema = V2RatelimitGetOverrideResponseBody$inboundSchema;
  /** @deprecated use `V2RatelimitGetOverrideResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    V2RatelimitGetOverrideResponseBody$outboundSchema;
  /** @deprecated use `V2RatelimitGetOverrideResponseBody$Outbound` instead. */
  export type Outbound = V2RatelimitGetOverrideResponseBody$Outbound;
}

export function v2RatelimitGetOverrideResponseBodyToJSON(
  v2RatelimitGetOverrideResponseBody: V2RatelimitGetOverrideResponseBody,
): string {
  return JSON.stringify(
    V2RatelimitGetOverrideResponseBody$outboundSchema.parse(
      v2RatelimitGetOverrideResponseBody,
    ),
  );
}

export function v2RatelimitGetOverrideResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V2RatelimitGetOverrideResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      V2RatelimitGetOverrideResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V2RatelimitGetOverrideResponseBody' from JSON`,
  );
}
